import React from 'react';
import * as PropTypes from 'prop-types';

import Button from '../../../../../Button';
import SignConsentButton from '../SingConsentButton';

import { handleNumberOfCount } from '../../utils/handleNumberOfCount';

import styles from '../index.styl';

export function ConsentDetailsSelfSchedulingView({
  allConsents,
  buttonAccept,
  buttonDecline,
  consentOutcomeTitles,
  consentTypeName,
  consentVersionTitle,
  createMarkup,
  handleAcceptConsent,
  handleClosePopup,
  id,
  isConsentHasMultipleOutcomes,
  isSignConsentLoading,
  name,
  providerContext,
  version,
}) {
  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.contentHeader}>
          <div className={styles.mainTitle}>
            <div className={styles.consentTitle}>{name}</div>
            <div
              className={styles.consentSubTitle}
            >{`${consentTypeName}, ${consentVersionTitle} ${version}`}</div>
          </div>
          <div className={styles.counter}>
            {handleNumberOfCount(allConsents, id)}
          </div>
        </div>
        {/* eslint-disable-next-line react/no-danger */}
        <div className={styles.text} dangerouslySetInnerHTML={createMarkup()} />
        {!providerContext && (
          <div className={styles.mainConsentBtnWrapper}>
            <Button
              className={styles.declineButton}
              onClick={handleClosePopup}
              color="accent"
            >
              {buttonDecline}
            </Button>
            <SignConsentButton
              buttonAccept={buttonAccept}
              handleAcceptConsent={handleAcceptConsent}
              isConsentHasMultipleOutcomes={isConsentHasMultipleOutcomes}
              isSignConsentLoading={isSignConsentLoading}
              titles={consentOutcomeTitles}
            />
          </div>
        )}
      </div>
    </div>
  );
}

ConsentDetailsSelfSchedulingView.propTypes = {
  allConsents: PropTypes.array,
  buttonAccept: PropTypes.string,
  buttonDecline: PropTypes.string,
  consentOutcomeTitles: PropTypes.arrayOf(PropTypes.string),
  consentTypeName: PropTypes.string,
  consentVersionTitle: PropTypes.string,
  createMarkup: PropTypes.func,
  handleAcceptConsent: PropTypes.func,
  handleClosePopup: PropTypes.func,
  id: PropTypes.number,
  isConsentHasMultipleOutcomes: PropTypes.bool,
  isSignConsentLoading: PropTypes.bool,
  name: PropTypes.string,
  providerContext: PropTypes.bool,
  version: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitConsents/ConsentDetailsPopup/ConsentDetailsSelfSchedulingView/index.jsx